/**
 * Text utility functions
 */

/**
 * Capitalizes the first letter of each word in a string
 * @param text - The text to capitalize
 * @returns The capitalized text
 *
 * @example
 * capitalize('pizza') // 'Pizza'
 * capitalize('omelette aux légumes') // 'Omelette Aux Légumes'
 */
export function capitalize(text: string): string {
  if (!text) return text;

  return text
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
